import type { TContactParam } from '@cian/newbuilding-chat-component';

import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EBuilderChatActionTypes {
  OpenChat = 'builderChat/open',
  CloseChat = 'builderChat/close',
  SetBuilderChatButtonClicked = 'builderChat/setBuilderChatButtonClicked',
}

export const openBuilderChat = actionGenerator<EBuilderChatActionTypes.OpenChat, TContactParam>(
  EBuilderChatActionTypes.OpenChat,
);

export const closeBuilderChat = actionGenerator<EBuilderChatActionTypes.CloseChat, void>(
  EBuilderChatActionTypes.CloseChat,
);

export const setBuilderChatButtonClicked = actionGenerator<EBuilderChatActionTypes.SetBuilderChatButtonClicked, void>(
  EBuilderChatActionTypes.SetBuilderChatButtonClicked,
);

export type TBuilderChatActions =
  | ReturnType<typeof openBuilderChat>
  | ReturnType<typeof closeBuilderChat>
  | ReturnType<typeof setBuilderChatButtonClicked>;
